import { useWizard } from '../../../context/WizardContext';
import { PaperCard } from '../../../components/wizard/PaperCard';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';

export function Step2Paper() {
  const { state, setPaper } = useWizard();
  const papers = state.selectedSubject?.papers ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">Select a Paper</h2>
        <p className="text-sm text-slate-500 mt-1">
          Choose the paper for{' '}
          <span className="font-medium text-slate-300">{state.selectedSubject?.name}</span>.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {papers.map((paper) => (
          <PaperCard
            key={paper.id}
            paper={paper}
            isSelected={state.selectedPaper?.id === paper.id}
            onSelect={setPaper}
          />
        ))}
      </div>
      <NavigationButtons />
    </div>
  );
}
